"use client";

import { Overlay, Portal, Root } from "@radix-ui/react-dialog";
import { AnimatePresence, motion } from "motion/react";
import type { ReactNode } from "react";
import React from "react";

import { cn } from "../../../utils";

export interface ModalContainerProps {
  open: boolean;
  children: ReactNode;
  onOpenChange?: (open: boolean) => void;
}

export const ModalContainer: React.FC<ModalContainerProps> = ({
  open,
  children,
  onOpenChange,
}) => {
  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <Portal forceMount>
        <AnimatePresence>
          {open && (
            <Overlay asChild>
              <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                animate={{ opacity: 1, filter: "blur(16px)" }}
                className={cn(
                  "ui:fixed ui:inset-0 ui:bg-[#CDCDCD]/60 ui:blur-lg ui:dark:bg-black/80",
                )}
              />
            </Overlay>
          )}
        </AnimatePresence>
        <AnimatePresence>{open && children}</AnimatePresence>
      </Portal>
    </Root>
  );
};
